import React from "react";
import Sidebar from "../Sidebar";
import { UserProfileData } from "../../FetchAPI";
import { Link } from "react-router-dom";
// import Tooltip from "@mui/material/Tooltip";
import DeshBoardFooter from "../DeshBoardFooter";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import { Helmet } from "react-helmet";
import { useAuth } from "../../../Store/AuthContext";
import "./Profile.css";

export default function Profile() {
  const { RendomTokenfetch, userRoll } = useAuth();
  const [ProfileuserData, loading] = UserProfileData(RendomTokenfetch);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb page1={[{ name: "My Profile" }]} />
        {loading ? (
          <p className="text-center">Loading...</p>
        ) : (
          <>
            <section className=" user-dashboard company_detail">
              <div className="dashboard-outer">
                <div className="company_detail_image">
                  {ProfileuserData.banner !== "" ? (
                    <img
                      src={`${ProfileuserData.base_url}${ProfileuserData.banner}`}
                      alt="avatar"
                      className="thumb "
                    />
                  ) : (
                    <img
                      src="images/bannerUser.jpg"
                      alt="avatar"
                      className="thumb "
                    />
                  )}
                </div>

                <div className="container-fluid px-0">
                  <div className="d-flex justify-content-between  flex-wrap">
                    <div className="company_detail_content">
                      <div className="company_detail_image_2">
                        {ProfileuserData.image !== "" ? (
                          <img
                            src={`${ProfileuserData.base_url}${ProfileuserData.image}`}
                            alt="avatar"
                            className="thumb"
                          />
                        ) : (
                          <img
                            src="images/blankUser.png"
                            alt="avatar"
                            className="thumb"
                          />
                        )}
                      </div>
                      <div className="company_detail_content_in">
                        <h4>
                          {ProfileuserData.username && ProfileuserData.username}
                        </h4>
                        <p>
                          <i
                            className="fa fa-envelope icon me-2"
                            aria-hidden="true"
                          ></i>{" "}
                          {ProfileuserData.email && ProfileuserData.email}
                        </p>
                      </div>
                    </div>

                    <div className="">
                      <Link
                        to="/profile-edit"
                        className="AllsiteButton mt-4 mx-2"
                      >
                        <i className="fa fa-pen-to-square"></i> Profile Edit{" "}
                      </Link>
                      {userRoll === "4" ? (
                        <Link
                          to="/account-details-update"
                          className="AllsiteButton mt-4 "
                        >
                          <i className="fa fa-pen-to-square mx-1"></i>Account
                          Update{" "}
                        </Link>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>

                <div className="mt-4 d-block">
                  <div className="row">
                    <div className="col-md-5">
                      <div className="intro">
                        <div className="intro1">
                          <h3>Intro</h3>
                        </div>
                        <ul>
                          {ProfileuserData.address && (
                            <li className="introLi">
                              <i className="fa fa-location"></i>
                              {ProfileuserData.address}
                            </li>
                          )}
                          {ProfileuserData.email && (
                            <li className="introLi">
                              <i
                                className="fa fa-envelope"
                                aria-hidden="true"
                              ></i>
                              {ProfileuserData.email}
                            </li>
                          )}
                          {ProfileuserData.number && (
                            <li className="introLi">
                              <i className="fa fa-phone"></i>
                              {ProfileuserData.number}
                            </li>
                          )}
                          {ProfileuserData.facebook_link && (
                            <li className="introLi">
                              <i className="fa fa-facebook"></i>{" "}
                              {ProfileuserData.facebook_link}
                            </li>
                          )}
                          {ProfileuserData.instagram_link && (
                            <li className="introLi">
                              <i className="fa fa-instagram"></i>
                              {ProfileuserData.instagram_link}
                            </li>
                          )}
                          {ProfileuserData.linkedin_link && (
                            <li className="introLi">
                              <i className="fa fa-linkedin"></i>
                              {ProfileuserData.linkedin_link}
                            </li>
                          )}
                          {ProfileuserData.twitter_link && (
                            <li className="introLi">
                              <i className="fa fa-twitter"></i>
                              {ProfileuserData.twitter_link}
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                    {userRoll === "4" ? (
                      <div className="col-md-7">
                        <div className="intro">
                          <div className=" orderleadbox ">
                            <h3 className="mb-0">Account Details</h3>
                            {/* <Tooltip
                            title="Convert My Number Order"
                            placement="top"
                            arrow
                          >
                            <Link className="AllsiteButton">Convert Order</Link>
                          </Tooltip> */}
                          </div>
                          <div
                            className="orderleadtable accountDataRow"
                            style={{ overflowX: "auto" }}
                          >
                            <table className="details-table AccountTableData">
                              <tbody>
                                {ProfileuserData.account_number && (
                                  <tr>
                                    <td className="label">Acc/No.</td>
                                    <td className="accTD">
                                      {ProfileuserData.account_number}
                                    </td>
                                  </tr>
                                )}
                                {ProfileuserData.bank_name && (
                                  <tr>
                                    <td className="label">Bank Name</td>
                                    <td className="accTD">
                                      {ProfileuserData.bank_name}
                                    </td>
                                  </tr>
                                )}
                                {ProfileuserData.account_holder && (
                                  <tr>
                                    <td className="label">Acc. Holder Name</td>
                                    <td className="accTD">
                                      {ProfileuserData.account_holder}
                                    </td>
                                  </tr>
                                )}
                                {ProfileuserData.ifsc_code && (
                                  <tr>
                                    <td className="label">IFSC Code</td>
                                    <td className="accTD">
                                      {ProfileuserData.ifsc_code}
                                    </td>
                                  </tr>
                                )}
                                {ProfileuserData.upiId && (
                                  <tr>
                                    <td className="label">UPI ID</td>
                                    <td className="accTD">
                                      {ProfileuserData.upiId}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
